<template>
    <div>
        <GetPaymentPopup 
            v-if="getPaymentFlag"
            @close="getPaymentFlag = false"
            @updateTransactions="updateTransactions"
        />
        <IncomeFilterPopup 
            v-if="showPopup"
            :filters = "filtersModel"
            @close="showPopup = false"
            @setFilters="filters => setFilters(filters)"
            @clearFilters="clearFilters"
        />
        <ImageViewer 
            v-if="showPictureFlag"
            :imageUrl="showPictureUrl"
            :altText="showPictureUrl"
            @close="showPictureFlag = false"
        />
        <AddInvest 
            v-if="showAddInvestPopup"
            @close="showAddInvestPopup = false"
            @updateTransactions="updateTransactions"
        />
        <GetIncomePopup 
            v-if="getIncomeFlag"
            @close="getIncomeFlag = false"
            @updateTransactions="updateTransactions"
        />

        <DeleteIncomeForm 
            v-if="deleteIncomeFlag"
            :income="incomeForDeletion"
            @close="deleteIncomeFlag = false"
            @acceptDeleteIncome="i => deleteIncome(i)"
        />

        <div class="w-[1290px] mx-auto">
            <div class="mt-[10px] flex justify-between w-[90%] items-center mx-auto mb-[30px]">
                <div>
                    <!-- <button @click="getPaymentFlag = true" class="bg-gray-500 px-2 align-middle rounded-md text-sm py-[2px] ml-[5px] hover:bg-opacity-90 text-[#FFF] ">
                        Прийняти кошти
                    </button>   -->
                    <button @click="showAddInvestPopup = true" class="bg-gray-500 px-2 align-middle rounded-md text-sm py-[2px] ml-[5px] hover:bg-opacity-90 text-[#FFF] ">
                        Додати інвестицію
                    </button>  
                    <button @click="getIncomeFlag = true" class="bg-gray-500 px-2 align-middle rounded-md text-sm py-[2px] ml-[5px] hover:bg-opacity-90 text-[#FFF] ">
                        Додати надходження
                    </button>  
                    <!-- <input type="text" v-model="receiverQuery"> -->
                    <!-- <button @click="" class="bg-gray-500 px-2 align-middle rounded-md text-sm py-[2px] ml-[5px] hover:bg-opacity-90 text-[#525A60] ">
                        Кастомна транзакція
                    </button>   -->
                </div>
                <div class="flex justify-end">
                    <div>
                        <!-- <span class="text-[#FFFFFF]">Кількість транзакцій:</span>
                        <input v-model="countOfTransactions" type="number" class="w-[50px] text-[#FFFFFF] outline-none ml-2 bg-transparent rounded-md pl-[5px]"> -->
                    
                        <div class="flex w-[110px] justify-between mr-[130px] text-[#525A60]">
                            <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer">
                            <div class="flex mx-[20px]">Сторінка: <input v-model="currentPage" type="number" class="bg-transparent mx-2 w-[5ch] outline-none px-1"> / <span class="ml-[10px]">{{ maxPage }}</span></div>
                            <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer">
                        </div>
                    </div>
                    <!-- <div>
                        <button @click="showPopup = true" class="bg-gray-500 px-2 rounded-md text-sm py-[2px] ml-[5px] hover:bg-opacity-90 text-[#FFF] ">
                            Фільтри
                        </button>    
                    </div> -->
                </div>
            </div>
    
            <div class="w-[90%] mx-auto mt-3 mb-[20px] rounded-[10px] overflow-auto" :key="tableObjectKey">
                <table class="w-full">
                    <thead class="select-none">
                        <tr class="text-[#525A60] border-b-[1px] border-[#252526]">
                            <th class="px-3 py-2 text-start font-medium text-sm">Оплату провів</th>
                            <th class="px-3 py-2 text-start font-medium text-sm">Клієнт</th>
                            <th class="px-3 py-2 text-start font-medium text-sm">Назва тарифу</th>
                            <th class="px-3 py-2 text-end font-medium text-sm">Сума</th>
                            <th class="px-3 py-2 text-center font-medium text-sm">Тип оплати</th>
                            <th class=" py-2 text-start font-medium text-sm">Дата</th>
                            <th class=" py-2 text-start font-medium text-sm">Час</th>
                            <th class="px-3 py-2 text-start font-medium text-sm"></th>
                        </tr>
                    </thead>
                    <tbody> 
                        <income-row 
                            v-for="income in showIncomes"
                            :income="income"
                            @addRecieverName="income.receiverName = $event"
                            @addRecieverStatus="income.receiverStatus = $event"
                            @showPicture="showPicture($event)"

                            @deleteTx="() => {deleteIncomeFlag = true; incomeForDeletion = income}"
                        />
                        <tr v-if="showIncomes.length == 0">
                            <td colspan="8" class="text-center text-[#525A60] opacity-25">
                                Нема надходжень
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    import { uuid } from 'vue3-uuid'
    import { useRouter, useRoute } from 'vue-router'
    import { ref, onMounted, watch, onUpdated } from 'vue'
    import { getCertainNumberOfIncomes, getIncomeTransactionById, getIncomeTransactionByBalanceId, getCountOfIncomes, deleteIncomeTransaction } from '@/services/apiRequests'
    import IncomeRow from './components/IncomeRow.vue'
    import IncomeFilterPopup from './components/IncomeFilterPopup.vue'
    import GetPaymentPopup from './components/GetPaymentPopup.vue'
    import ImageViewer from './ui/ImageViewer.vue'
    import AddInvest from './components/AddInvest.vue'
    import GetIncomePopup from './components/GetIncomePopup.vue'
    import DeleteIncomeForm from './components/DeleteIncomeForm.vue'

    export default {
        name: 'Incomes', 

        setup() {
            const countOfTransactions = ref(10)
            const allIncomes = ref([])
            const showIncomes = ref([])
            const tableObjectKey = ref(uuid.v1())
            const showPopup = ref(false)
            const filtersModel = ref({
                receiver_type: 'all',
                transaction_type: 'all',
                amount_from: null,
                amount_to: null,
                date_from: null,
                date_to: null,
                current_balance_id: null,
                current_transaction_id: null,
                transaction_origin: 'all'
            })
            const router = useRouter()
            const route = useRoute()

            const showPictureFlag = ref(false)
            const showPictureUrl = ref({})

            const getPaymentFlag = ref(false)
            const getIncomeFlag = ref(false)

            const showAddInvestPopup = ref(false)

            const currentPage = ref(1)
            const maxPage = ref(100)

            const receiverQuery = ref('')
            const deleteIncomeFlag = ref(false)
            const incomeForDeletion = ref({})

            const prevPage = () => {
                currentPage.value > 1 ? currentPage.value-- : currentPage.value = 1
            }

            const nextPage = () => {
                currentPage.value += 1
            }

            const deleteIncome = async (income) => {
                console.log('income ------ ', income)
                await deleteIncomeTransaction(income.tx_id)
                deleteIncomeFlag.value = false
                updateTransactions()
            }

            const clearFilters = async () => {
                filtersModel.value = {
                    receiver_type: 'all',
                    transaction_type: 'all',
                    amount_from: null,
                    amount_to: null,
                    date_from: null,
                    date_to: null,
                    current_balance_id: null,
                    current_transaction_id: null,
                    transaction_origin: 'all'
                }
                showPopup.value = false

                const unmappedTransactions = (await getCertainNumberOfIncomes(20, 0)).transactions
                allIncomes.value = mapTransactions(unmappedTransactions)
                showIncomes.value = allIncomes.value
                tableObjectKey.value = uuid.v1()
                
                router.push('/incomes')
            }

            const showPicture = (url) => {
                showPictureUrl.value = process.env.VUE_APP_API_URL + 'static/' + url
                showPictureFlag.value = true
            }

            const mapTransactions = (unmappedTransactions) => {
                console.log('unmappedTransactions ----- ', unmappedTransactions)
                return unmappedTransactions.map(income => {
                    const date = income.date.split('T')[0].split('-').reverse().join('.')
                    const time = income.date.split('T')[1].split('.')[0].split(':').slice(0, 2).join(':')
                    const transactionType = income.transactions_type.includes('virtual') ? 'Віртуальна' : 'Реальна'
                    const amount = income.amount
                    return {
                        receiverName: null,
                        receiverStatus: null,
                        student_name: income.student_name,
                        student_id: income.student_id,
                        tariff_name: income.tariff_name?.replace('SPLIT', 'DUO'),
                        transactions_purpose: income.transactions_purpose,
                        tariff_id: income.tariff_id,
                        prepaid_income: income.prepaid_income,
                        new_prepaid_balance: income.new_prepaid_balance,
                        receiverBalanceId: income.receiver_balance_id,
                        id: income.tx_id,
                        income_type: income.income_type,
                        label: income.label,
                        embedVirtualIncomeId: income.embed_virtual_income,
                        additional_files: income.additional_files,
                        manager_label: income.manager_label,
                        date,
                        time,
                        transactionType,
                        amount,
                        tx_id: income.tx_id
                    }
                })
            }

            const updateTransactions = async () => {
                if (route.params.tx_id || route.params.balance_id) {
                    await filterByTxOrBalanceIds()
                } else {
                    const unmappedTransactions = (await getCertainNumberOfIncomes(20, 0, filtersModel.value)).transactions
                    allIncomes.value = mapTransactions(unmappedTransactions)
                    showIncomes.value = allIncomes.value
                }
            }

            onMounted(async () => {
                await updateTransactions()
            })

            const filterByTxOrBalanceIds = async () => {
                filtersModel.value.current_transaction_id = route.params.tx_id
                filtersModel.value.current_balance_id = route.params.balance_id

                if (route.params.tx_id) {
                    const unmappedTransactions = [(await getIncomeTransactionById(route.params.tx_id)).transaction, ]
                    allIncomes.value = mapTransactions(unmappedTransactions)
                    showIncomes.value = allIncomes.value
                    tableObjectKey.value = uuid.v1()
                } else if (route.params.balance_id) {
                    console.log(await getIncomeTransactionByBalanceId(route.params.balance_id))
                    const unmappedTransactions = (await getIncomeTransactionByBalanceId(route.params.balance_id)).transactions
                    allIncomes.value = mapTransactions(unmappedTransactions)
                    showIncomes.value = allIncomes.value
                    tableObjectKey.value = uuid.v1()
                }
            }

            watch(route, async () => {
                console.log('a')
                if (route.params.tx_id || route.params.balance_id) {
                    await filterByTxOrBalanceIds()
                } else {
                    console.log('a')
                    const unmappedTransactions = (await getCertainNumberOfIncomes(20, 0, filtersModel.value)).transactions
                    allIncomes.value = mapTransactions(unmappedTransactions)
                    showIncomes.value = allIncomes.value
                    tableObjectKey.value = uuid.v1()
                }
            })

            watch(currentPage, async () => {
                const unmappedTransactions = (await getCertainNumberOfIncomes(20, 20 * (currentPage.value - 1), filtersModel.value)).transactions
                allIncomes.value = mapTransactions(unmappedTransactions)
                showIncomes.value = allIncomes.value
                tableObjectKey.value = uuid.v1()
            })

            const setFilters = async (filters) => {
                filtersModel.value = filters
                showPopup.value = false

                const unmappedTransactions = (await getCertainNumberOfIncomes(20, 0, filters)).transactions
                allIncomes.value = mapTransactions(unmappedTransactions)
                showIncomes.value = allIncomes.value
                tableObjectKey.value = uuid.v1()
            }

            return {
                countOfTransactions,
                allIncomes,
                tableObjectKey,
                showPopup,
                setFilters,
                showIncomes,
                filtersModel,
                router,
                clearFilters,
                getPaymentFlag,
                updateTransactions,
                showPicture,
                showPictureFlag,
                showPictureUrl,
                showAddInvestPopup,
                currentPage, 
                maxPage,
                prevPage,
                nextPage,
                receiverQuery,
                getIncomeFlag,
                incomeForDeletion,
                deleteIncomeFlag,
                deleteIncome
            }
        },

        components: {
            IncomeRow,
            IncomeFilterPopup,
            GetPaymentPopup,
            ImageViewer,
            AddInvest,
            GetIncomePopup,
            DeleteIncomeForm
        }
    }
</script>

<style lang="scss" scoped>

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance: textfield;
}

</style>